// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_25-6";
export var headerCell = "_25-2";
export var rowWrapper = "_25-4";
export var stickyAggregationCell = "_25-a";
export var stickyAggregationRow = "_25-7";
export var stickyColumnCell = "_25-9";
export var stickyColumnHeaderCell = "_25-8";
export var table = "_25-1";
export var virtualRowWrapper = "_25-5";
export var virtualTableContainer = "_25-0";
export var white = "_25-3";